import { SyncSeatingOrderReducer } from './types'

export const syncSeatingOrderDefaultReducerState: SyncSeatingOrderReducer = {
  seatingOrder: {}
}

export default syncSeatingOrderDefaultReducerState
